import { render } from "./Collegues.vue?vue&type=template&id=488d7362&scoped=true"
import script from "./Collegues.vue?vue&type=script&lang=js"
export * from "./Collegues.vue?vue&type=script&lang=js"

import "./Collegues.vue?vue&type=style&index=0&id=488d7362&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488d7362"]])

export default __exports__